import { PropsWithChildren } from "react";
import { Box } from "@mui/material";

interface GradientBoxProps extends PropsWithChildren {
  minHeight?: string;
}

const GradientBox = ({ children, minHeight = "100vh" }: GradientBoxProps) => {
  return (
    <Box
      sx={{
        minHeight,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background:
          "linear-gradient(225deg, #0f0a0e 0%, #000 50%, #150a0f 100%)",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: "20%",
          left: "20%",
          width: "300px",
          height: "300px",
          background: "rgba(210, 100, 21, 0.3)",
          borderRadius: "50%",
          filter: "blur(100px)",
          zIndex: 0,
        },
        "&::after": {
          content: '""',
          position: "absolute",
          bottom: "10%",
          right: "15%",
          width: "400px",
          height: "400px",
          background: "rgba(210, 100, 21, 0.3)",
          borderRadius: "50%",
          filter: "blur(120px)",
          zIndex: 0,
        },
      }}
    >
      {children}
    </Box>
  );
};

export default GradientBox;
